import styled from "styled-components"

export default styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #00000066;
    backdrop-filter: blur(6px);
`